export const getBergeracData = () => ({
  name: "Bergerac",
  region: "Sud-Ouest",
  country: "France",
  description: "Bergerac est une appellation importante du Sud-Ouest de la France, produisant des vins rouges et blancs de qualité. Cette région bénéficie d'un terroir favorable et d'une longue tradition viticole.",
  type: "subregion",
  area: "12,000 ha",
  production: "600,000 hectolitres",
  mapAreas: [
    { region: "Bergerac", x: 0.5, y: 44.8, color: "#4B164C", size: 5 }
  ],
  characteristics: {
    climate: "Climat océanique tempéré, étés chauds, hivers doux",
    soil: "Sols variés : calcaires, argiles, sables, excellente diversité géologique",
    viticulture: "Viticulture traditionnelle, rendements contrôlés"
  },
  wineStyles: {
    red: "Vins rouges fruités et équilibrés, avec des tanins mûrs",
    white: "Vins blancs secs et aromatiques, avec une belle acidité",
    sweet: "Vins blancs moelleux et complexes (Monbazillac)"
  },
  history: "La viticulture à Bergerac remonte à l'époque romaine. Au Moyen Âge, les monastères ont développé la viticulture. La région a bénéficié de l'influence bordelaise tout en gardant son identité propre. Aujourd'hui, Bergerac est reconnue pour ses vins de qualité et sa diversité.",
  foodPairing: "Cuisine du Sud-Ouest, viandes blanches, poissons, fromages, foie gras",
  grapeVarieties: [
    {
      name: "Merlot",
      percentage: "50%",
      description: "Cépage principal pour les vins rouges, apportant rondeur et fruité",
      characteristics: "Fruité, tanins doux, structure équilibrée",
      wineStyles: "Sec, moyen-corps, fruité"
    },
    {
      name: "Cabernet Sauvignon",
      percentage: "25%",
      description: "Cépage d'assemblage, apportant structure et tanins",
      characteristics: "Structuré, tanins fermes, notes de cassis",
      wineStyles: "Sec, plein-corps, tannique"
    },
    {
      name: "Sémillon",
      percentage: "15%",
      description: "Cépage blanc principal, pour vins secs et moelleux",
      characteristics: "Riche, miel, notes de fruits secs",
      wineStyles: "Sec à moelleux, moyen-corps, complexe"
    },
    {
      name: "Sauvignon Blanc",
      percentage: "10%",
      description: "Cépage blanc aromatique, pour vins secs",
      characteristics: "Aromatique, acidité vive, notes d'agrumes",
      wineStyles: "Sec, léger, aromatique"
    }
  ],
  subregions: {
    "bergerac-rouge": {
      name: "Bergerac Rouge",
      description: "Zone de production des vins rouges de Bergerac",
      characteristics: {
        climate: "Climat océanique tempéré",
        soil: "Sols calcaires et argileux",
        viticulture: "Viticulture traditionnelle"
      },
      grapeVarieties: {
        red: ["Merlot", "Cabernet Sauvignon", "Cabernet Franc"]
      },
      wineStyles: {
        red: "Vins rouges fruités et équilibrés"
      },
      foodPairing: "Viandes blanches, volailles, fromages"
    },
    "monbazillac": {
      name: "Monbazillac",
      description: "Zone de production des vins blancs moelleux",
      characteristics: {
        climate: "Climat favorable à la pourriture noble",
        soil: "Sols argilo-calcaires",
        viticulture: "Viticulture traditionnelle"
      },
      grapeVarieties: {
        white: ["Sémillon", "Sauvignon Blanc", "Muscadelle"]
      },
      wineStyles: {
        sweet: "Vins blancs moelleux et complexes"
      },
      foodPairing: "Foie gras, desserts, fromages bleus"
    }
  }
}); 